# Service to instantly push customer email and id to dataLayer
export addGtmCustomerSubscribers = (store, gtmEcomm) ->

	# Fire events when customer data is set
	store.subscribe ({ type, payload }, state) ->
		if type == 'customer/setCustomer'
		then gtmEcomm.identifyCustomer state.customer
